import { ref } from 'vue'
import { useStore } from 'vuex'
import GetLabel from 'foundation/js/getLabel'

export default {
    name: 'FlowEditModal',
    setup() {
        const changesSaved = ref(false)
        const store = useStore()

        const saveChanges = function (e) {
            changesSaved.value = true
        }

        const closeModal = function (e) {
            store.dispatch('main/closePageOverlay')
        }

        return {
            getLabel: (labelKey) => GetLabel({ labelKey, labelCollection: 'personalFundraising' }),
            saveChanges,
            closeModal,
            changesSaved
        }
    }
}
